import "./GetQuote.module.css";
import Header from "@/reusable_sections/Header";
import StartYourMove from "./sections/StartYourMove";
import OurServiceArea from "./sections/OurServiceArea";
import Footer from "@/reusable_sections/Footer";
export default function GetQuotePage() {
  return <div>
      <Header />
      <StartYourMove />
      <OurServiceArea />
      <Footer />
    </div>;
}